import React from 'react';
import { FaMapMarkerAlt, FaDirections } from 'react-icons/fa';
import './Location.css';

const Location = () => {
  return (
    <section id="location" className="location-section">
      <div className="container">
        <h2 className="section-title">Lokacija</h2>

        <div className="location-content">
          <div className="location-info">
            <h3><FaMapMarkerAlt /> Adresa</h3>
            <p>Piskavica bb, 75000 Tuzla</p>

            <h3>Kako do nas</h3>
            <p>
              Odmaralište Hana se nalazi u mirnom dijelu Tuzle, okruženo prirodom.
              Lokacija je lako dostupna automobilom, a udaljena je samo 4km od centra grada Tuzle.
            </p>

            <div className="directions-btn">
              <a
                href="https://maps.google.com/?q=44.552542,18.652694"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaDirections /> Navigacija do lokacije
              </a>
            </div>
          </div>

          <div className="location-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1421.4438405828292!2d18.65269356110905!3d44.5525416958714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDTCsDMzJzA5LjIiTiAxOMKwMzknMDkuNyJF!5e0!3m2!1sen!2sba!4v1748010566216!5m2!1sen!2sba"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Odmaralište Hana location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
